import { getAuth } from "firebase/auth";
import logo from '../assets/milogo.png';
import config from '../utils/EnvironmentSwitcher';
// FHIR ENDPOINTS
export const FHIR_API_ENDPOINT = `${config.fhirUrl}`;
export const FHIR_BASE = `${config.fhirUrl}/fhir`;
export const IPFS_API_ENDPOINT = 'https://ipfs.mieros.cloud';
export const FHIR_API_ENDPOINT_PERSON = `${config.fhirUrl}/fhir/Person`;
export const FHIR_API_ENDPOINT_PATIENT = `${config.fhirUrl}/fhir/Patient`;
export const FHIR_API_ENDPOINT_OBSERVATION = `${config.fhirUrl}/fhir/Observation`;
export const API_SOCKET_ENDPOINT = 'wss://mieapi.mieros.cloud/ws/';
export const API_ENDPOINT = 'https://mieapi.mieros.cloud';

// FHIR Observation LOINC codes for vital signs
export const LOINC_CODES = {
  HEART_RATE: '8867-4',
  BODY_TEMPERATURE: '8310-5',
  OXYGEN_SATURATION: '59408-5',
  BLOOD_GLUCOSE: '2339-0',
  BODY_HEIGHT: '8302-2',
  BODY_WEIGHT: '29463-7',
  SYSTOLIC_BP: '8480-6',
  DIASTOLIC_BP: '8462-4'
};
export const API_ENDPOINT_USERLOGIN = `${API_ENDPOINT}/user/login`;
export const API_ENDPOINT_USERREGISTER = `${API_ENDPOINT}/user/register`;
export const API_ENDPOINT_GETUSER_ITEMS = `${API_ENDPOINT}/nft/me`;
// NFT metadata lives on the MiE API; IPFS gateway is for content CIDs only.
export const API_ENDPOINT_GETITEM_BYID = (nftID) => `${API_ENDPOINT}/nft/${nftID}`;
export const IPFS_GATEWAY_URL = (cid) => `${IPFS_API_ENDPOINT}/ipfs/${cid}`;
export const API_ENDPOINT_GETITEM_HISTORY_BYID = (nftID) => `${API_ENDPOINT}/nft/${nftID}/history`;
export const API_ENDPOINT_ADDITEM = `${API_ENDPOINT}/nft/mint`;
export const API_ENDPOINT_ITEM_TRANSFER = `${API_ENDPOINT}/nft/transfer`;
export const API_ENDPOINT_ADDAUCTION_ITEM = `${API_ENDPOINT}/auction/init`;
export const API_ENDPOINT_GETAUCTION_ITEMS = `${API_ENDPOINT}/auction/init`;
export const API_ENDPOINT_ADDAUCTION_OPEN_ITEM = `${API_ENDPOINT}/auction/open`;
export const API_ENDPOINT_GETAUCTION_OPEN_ITEMS = `${API_ENDPOINT}/auction/open`;
export const API_ENDPOINT_GETAUCTION_OPEN_ITEMS_BY_AH = `${API_ENDPOINT}/auction/open/auctionHouse`;
export const API_ENDPOINT_ADDBID = `${API_ENDPOINT}/bid`;
export const API_ENDPOINT_GETHIGHBID_BYID = (auctionId) => `${API_ENDPOINT}/bid/high/${auctionId}`;
export const API_ENDPOINT_BID_BUYNOW = `${API_ENDPOINT}/bid/buyNow`;
export const API_ENDPOINT_AUCTION_CLOSE = `${API_ENDPOINT}/auction/close`;

// Add new marketplace endpoints
export const API_ENDPOINT_MARKETPLACE_LIST = `${API_ENDPOINT}/nft/marketplace/list`;
export const API_ENDPOINT_MARKETPLACE_BUY = `${API_ENDPOINT}/nft/marketplace/buy`;
export const API_ENDPOINT_MARKETPLACE_CANCEL = `${API_ENDPOINT}/marketplace/cancel`;
export const API_ENDPOINT_MARKETPLACE_UPDATE_PRICE = `${API_ENDPOINT}/marketplace/update-price`;
export const API_ENDPOINT_MARKETPLACE_LISTINGS = `${API_ENDPOINT}/nft/marketplace/listings`;
export const API_ENDPOINT_MARKETPLACE_HISTORY = (listingId) => `${API_ENDPOINT}/marketplace/history/${listingId}`;
export const API_ENDPOINT_MARKETPLACE_USER_LISTINGS = (userId) => `${API_ENDPOINT}/marketplace/user/${userId}/listings`;
export const API_ENDPOINT_MARKETPLACE_NOTIFICATIONS = `${API_ENDPOINT}/marketplace/notifications`;

export const CURRENT_USER = () => JSON.parse(localStorage.getItem('userSession')) || {};

export const HEADERS = async () => {
      const auth = getAuth();
      const user = auth.currentUser;
      const token = user ? await user.getIdToken() : null;

      return new Headers({
            'Content-Type': 'application/json',
            ...(token && { 'Authorization': `Bearer ${token}` }), // Conditionally add the Authorization header
      });
};

export const FHIRHEADERS = async () => {
      const auth = getAuth();
      const user = auth.currentUser;
      const token = user ? await user.getIdToken() : null;

      return new Headers({
            'Content-Type': 'application/fhir+json',
            ...(token && { 'Authorization': `Bearer ${token}` }), // Conditionally add the Authorization header
      });
};

export const AJAXHEADERS = async () => {
      const auth = getAuth();
      const user = auth.currentUser;
      const token = user ? await user.getIdToken() : null;

      return {
            'Content-Type': 'application/json',
            ...(token && { 'Authorization': `Bearer ${token}` }), // Conditionally add the Authorization header
      };
};

// Other constants
export const SITE_NAME = "MiE NFT Marketplace";
export const SITE_LOGO = logo;
export const REQUESTDATE_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const MAX_FILEUPLOAD_SIZE = "20"; // in MB

// Add marketplace status constants
export const LISTING_STATUS = {
    LISTED: 'LISTED',
    SOLD: 'SOLD',
    CANCELLED: 'CANCELLED',
    REMOVED: 'REMOVED',
    ADMIN_REMOVED: 'ADMIN_REMOVED'
};

export const USER_STATUS = {
    ACTIVE: 'ACTIVE',
    SUSPENDED: 'SUSPENDED',
    BANNED: 'BANNED'
};
